import ChevronRight from '@mui/icons-material/ChevronRight';
import { Button, Box } from '@mui/material';
import { ButtonProps } from '@mui/material';

interface ButtonCardProps extends ButtonProps {
  label: string;
  onClick: () => void;
  sublabel?: string;
  disabled?: boolean;
}

export const ButtonCard = ({
  disabled,
  onClick,
  label,
  sublabel,
  ...rest
}: ButtonCardProps) => {
  return (
    <Button
      {...rest}
      variant='outlined'
      onClick={onClick}
      disabled={disabled}
      endIcon={<ChevronRight />}
      sx={{
        py: 2,
        gap: 4,
        justifyContent: 'space-between',
        cursor: 'pointer',
      }}
    >
      <Box
        component='span'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          cursor: 'pointer',
        }}
      >
        {label}
        {sublabel && (
          <Box
            sx={{ fontSize: '12px', textAlign: 'left' }}
            component='span'
          >
            {sublabel}
          </Box>
        )}
      </Box>
    </Button>
  );
};
